import React from 'react';
import { useSelector } from 'react-redux';

import './style.scss';

export default function CoverageSummary(props) {
  const { insuranceSelected } = useSelector(({ insurances }) => ({
    insuranceSelected: insurances.selected,
  }));

  const { insuranceName } = insuranceSelected || {};

  const { userCarInsurance } = useSelector(({ carInsurance }) => ({
    userCarInsurance: carInsurance.userCarInsurance,
    carTotalAmountInsured: carInsurance.userCarInsurance.carTotalAmountInsured,
  }));

  let totalAmount = 0;

  return (
    <div className='Container-CoverageSummary'>
      <div className='Type-Of-Plan-CoverageSummary'>
        <span className='Heading-CoverageSummary'>
          <b>
            <span className='capitalize'>{props.insuranceName}</span> -{' '}
            {props.planDescription}
          </b>
        </span>
      </div>

      <div className='Coverage-Item-Container-CoverageSummary'>
        {props.coverage.map((coverage) => {
          let amount = coverage.amount.replace(/,/g, '');
          amount = amount.split('.')[0];
          totalAmount += parseInt(amount);
          return (
            <div
              key={coverage.description}
              className='Coverage-Item-CoverageSummary'
            >
              <div className='Coverage-Description-Container'>
                <div className='Icon-Container-CoverageSummary'>
                  <i className='tiny material-icons'>check</i>
                </div>
                <div className='Text-Container-CoverageSummary'>
                  {coverage.description}
                </div>
              </div>
              {insuranceName !== 'AUTOMOTOR' ? (
                <div className='Price-Summary-CoverageSummary'>
                  ${coverage.amount}
                </div>
              ) : (
                ''
              )}
            </div>
          );
        })}

        <div className='Summary-Container-CoverageSummary'>
          <div className='Text-Container-CoverageSummary'>
            SUMA TOTAL ASEGURADA
          </div>
          {insuranceName !== 'AUTOMOTOR' ? (
            <div className='Price-Summary-CoverageSummary'>
              ${totalAmount.toLocaleString()}
            </div>
          ) : (
            <div className='Price-Summary-CoverageSummary'>
              ${parseFloat(userCarInsurance.carTotalAmountInsured).toFixed(0)}
            </div>
          )}
        </div>

        <div className='Payment-CoverageSummary'>
          <div className='Money-Container-CoverageSummary'>
            <span>${props.price ? parseFloat(props.price).toFixed(0) : 0}</span>
          </div>
          <div className='Type-Of-Payment-CoverageSummary'>
            <span>/mes</span>
          </div>
        </div>
      </div>
    </div>
  );
}
